import React from "react";

const Pagination = ({ page, totalPages, setPage }) => {
    if (totalPages <= 1) return null;

    const maxVisible = 3;
    const pages = [];

    const addPage = (p) => {
        pages.push(
            <button
                key={p}
                className={`pagination-btn ${page === p ? "active" : ""}`}
                onClick={() => setPage(p)}
            >
                {p}
            </button>
        );
    };

    addPage(1);

    if (page > maxVisible + 2) {
        pages.push(<span key="dots-left">...</span>);
    }

    for (
        let p = Math.max(2, page - maxVisible);
        p <= Math.min(totalPages - 1, page + maxVisible);
        p++
    ) {
        addPage(p);
    }

    if (page < totalPages - (maxVisible + 1)) {
        pages.push(<span key="dots-right">...</span>);
    }

    if (totalPages > 1) {
        addPage(totalPages);
    }

    return (
        <div className="flex gap-[1vmax] justify-center mt-[2vmax]">
            <button
                className="pagination-btn"
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
            >
                Prev
            </button>

            {pages}

            <button
                className="pagination-btn"
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
            >
                Next
            </button>
        </div>
    );
};

export default Pagination;
